"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClientShortHandName;
(function (ClientShortHandName) {
    ClientShortHandName["AP"] = "AP";
    ClientShortHandName["ASK"] = "ASK";
    ClientShortHandName["BTI"] = "BTI";
    ClientShortHandName["BYN"] = "BYN";
    ClientShortHandName["DNB"] = "DNB";
    ClientShortHandName["DP"] = "DP";
    ClientShortHandName["MPL"] = "MPL";
    ClientShortHandName["SA"] = "SA";
    ClientShortHandName["SCH"] = "SCH";
    ClientShortHandName["STR"] = "STR";
    ClientShortHandName["VG"] = "VG";
    ClientShortHandName["VNY"] = "VNY";
    ClientShortHandName["E24"] = "E24";
    ClientShortHandName["BEDRIFT"] = "BEDRIFT";
    ClientShortHandName["RB24"] = "RB24";
    ClientShortHandName["BAREASANE"] = "BAREASANE";
    ClientShortHandName["OP"] = "OP";
    ClientShortHandName["SVD"] = "SVD";
    ClientShortHandName["OMNI"] = "OMNI";
    ClientShortHandName["AB"] = "AB";
    ClientShortHandName["WELLOBE"] = "WELLOBE";
    ClientShortHandName["VEKTKLUBB"] = "VEKTKLUBB";
})(ClientShortHandName || (ClientShortHandName = {}));
exports.default = ClientShortHandName;
//# sourceMappingURL=ClientShortHandName.js.map